// Shared value formatting for twin surfaces (mirrors the helpers the
// TargetsEditor journey track uses, so numbers read the same everywhere).

// "8h 24m" · "3,259 steps" · "94.4%"
export const formatValue = (v, unit) => {
  if (v === null || v === undefined) return '—';
  if (unit === 'min') {
    const h = Math.floor(v / 60);
    const m = Math.round(v % 60);
    return h > 0 ? (m > 0 ? `${h}h ${m}m` : `${h}h`) : `${m}m`;
  }
  const num = Number.isInteger(v)
    ? v.toLocaleString()
    : v.toLocaleString(undefined, { maximumFractionDigits: 1 });
  return unit === '%' || unit === '/10' ? `${num}${unit}` : `${num} ${unit}`;
};

// Bare number for compact labels — units sit elsewhere on the line
export const formatShort = (v, unit) => {
  if (v === null || v === undefined) return '—';
  if (unit === 'min') return formatValue(v, unit);
  return Number.isInteger(v)
    ? v.toLocaleString()
    : v.toLocaleString(undefined, { maximumFractionDigits: 1 });
};

// "7–9h" · "≥ 8,000 steps" · "≤ 100 bpm"
export const formatRange = (low, high, unit) => {
  if (low !== null && low !== undefined && high !== null && high !== undefined) {
    if (unit === 'min') return `${formatValue(low, unit)} – ${formatValue(high, unit)}`;
    const lo = Number.isInteger(low)
      ? low.toLocaleString()
      : low.toLocaleString(undefined, { maximumFractionDigits: 1 });
    return `${lo} – ${formatValue(high, unit)}`;
  }
  if (low !== null && low !== undefined) return `≥ ${formatValue(low, unit)}`;
  if (high !== null && high !== undefined) return `≤ ${formatValue(high, unit)}`;
  return null;
};

// Short date tick: "Jul 12"
export const formatDateTick = (iso) => {
  const d = new Date(iso + 'T00:00:00');
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};
